export default {
  namespaced: true,
  external_token: {
    title: "external token | external tokens",
    description: "description",
    token: "token",
  },
};
